import RadioGroup from './radioGroup';
// 常量
import type { RadioGroupProps } from './interface';

export type { RadioGroupProps, };

export default RadioGroup;
